import React from "react";
import { Divider, IconButton, makeStyles } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";

const useStyles = makeStyles((theme) => ({
  divider: {
    height: "20px",
  },
}));

function SongPartActions(props) {
  const classes = useStyles();

  return (
    <div>
      <IconButton
        edge="end"
        aria-label="add"
        onClick={() => props.handleSpecialChange(props.songPart.id)}
      >
        <AddIcon />
      </IconButton>

      <IconButton
        edge="end"
        disabled
        onClick={() => props.handleDelete(props.songPart.id)}
      >
        <Divider className={classes.divider} orientation="vertical" />
      </IconButton>

      <IconButton
        edge="end"
        aria-label="delete"
        onClick={() => props.handleDelete(props.songPart.id)}
      >
        <DeleteIcon />
      </IconButton>
    </div>
  );
}

export default SongPartActions;
